

import axios from 'axios';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { 
  BsPlus, 
  BsWallet2, 
  BsShieldCheck, 
  BsBell 
} from 'react-icons/bs';
import { 
  FaRegUserCircle, 
  FaGamepad, 
  FaHistory, 
  FaUsers, 
  FaGift, 
  FaHeadset, 
  FaPowerOff 
} from 'react-icons/fa';
import '../Components/Component-css/Header.css';
import css from './Component-css/Nav.module.css';

const w3_close = () => {
  const sidebar = document.getElementById('mySidebar');
  if (!sidebar) return;
  sidebar.style.left = `-${sidebar.offsetWidth}px`;
  document.getElementById('sidebarOverlay').style.display = 'none';
};

const w3_open = () => {
  const sidebar = document.getElementById('mySidebar');
  if (!sidebar) return;
  sidebar.style.left = '0';
  document.getElementById('sidebarOverlay').style.display = 'block';
};

const Header = ({ user }) => {
  const history = useHistory();
  const access_token = localStorage.getItem('token');
  
  const logout = () => {
    const headers = { Authorization: `Bearer ${access_token}` };
    axios
      .post(`https://api.kakaking.in/logout`, { headers }, { headers })
      .then(() => {
        localStorage.removeItem('token');
        window.location.reload();
        history.push('/');
      })
      .catch(e => {
        if (e.response?.status === 401) {
          localStorage.removeItem('token');
        }
      });
  };

  return (
    <div style={{ marginTop: '0px' }}>
      {access_token ? (
        <>
          {/* Enhanced Premium Overlay */}
          <div id="sidebarOverlay" onClick={w3_close} style={{
            position: 'fixed', display: 'none', width: '100%', height: '100%',
            top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgb(149 107 107 / 12%)', 
            backdropFilter: 'blur(5px)', zIndex: 1000
          }}></div>

          {/* Premium Glassmorphism Sidebar */}
          <div className="w3-sidebar w3-bar-block" id="mySidebar" style={{
            zIndex: 1001, width: '285px', 
            background: 'linear-gradient(165deg, rgb(26 26 22) 0%, rgb(125 109 95 / 68%) 100%)', 
            backdropFilter: 'blur(15px)',
            transition: '0.4s cubic-bezier(0.25, 1, 0.5, 1)', 
            left: '-285px', position: 'fixed', height: '100%', 
            overflowY: 'auto', borderRight: '1px solid rgba(255,255,255,0.08)',
            // boxShadow: '15px 0 35px rgba(0,0,0,0.6)'
          }}>
            
            {/* 1. GAMING HEADER AREA */}
            <div className="sidebar_header" style={{
              background: '#222051', padding: '20px', display: 'flex', 
              justifyContent: 'space-between', alignItems: 'center', height: '85px',
              // boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
            }}>
              <img src="/images/addanew.png" alt="logo" style={{ height: '52px', filter: 'drop-shadow(0 0 5px rgba(255,255,255,0.1))' }} />
              <button 
                onClick={w3_close} 
                style={{
                  background: 'rgba(78, 195, 201, 0.15)', border: '1.5px solid #4ec3c9', borderRadius: '10px', 
                  color: '#4ec3c9', width: '38px', height: '38px', cursor: 'pointer', 
                  display: 'flex', alignItems: 'center', justifyContent: 'center', transition: '0.3s'
                }}
              >
                <i className="fa fa-times" style={{ fontSize: '18px' }}></i>
              </button>
            </div>

            {/* 2. PREMIUM LIST ITEMS WITH REACT ICONS */}
            <div style={{ padding: '10px 0' }}>
              {[
                { to: "/Profile", icon: <FaRegUserCircle />, label: "My Profile", color: "#4ec3c9" },
                { to: "/landing", icon: <FaGamepad />, label: "Win cash", color: "#fff" },
                { to: "/wallet", icon: <BsWallet2 />, label: "My wallet", color: "#fff" },
                { to: "/transaction-history", icon: <FaHistory />, label: "History", color: "#fff" },
                { to: "/Referral-history", icon: <FaUsers />, label: "Refer History", color: "#fff" },
                { to: "/refer", icon: <FaGift />, label: "Refer and Earn", color: "#ffd700" }, // Gold for earning
                // { to: "/Notification", icon: <BsBell />, label: "Notification", color: "#fff" },
                { to: "/support", icon: <FaHeadset />, label: "Support", color: "#fff" },
                { to: "/AllPolicy", icon: <BsShieldCheck />, label: "All Policy", color: "#fff" },
              ].map((item, index) => (
                <Link 
                  key={index}
                  to={item.to} 
                  className="premium-nav-item" 
                  onClick={w3_close}
                  style={{
                    display: 'flex', alignItems: 'center', padding: '15px 25px',
                    borderBottom: '1px solid rgba(255,255,255,0.05)', color: '#d1d5db', 
                    textDecoration: 'none', transition: 'all 0.3s'
                  }}
                >
                  <div style={{ 
                    fontSize: '22px', 
                    color: item.color,
                    width: '32px', 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    filter: `drop-shadow(0 0 8px ${item.color}44)` 
                  }}>
                    {item.icon}
                  </div>
                  <span style={{ 
                    fontWeight: '500', 
                    fontSize: '15.5px', 
                    letterSpacing: '0.5px', 
                    color: "#fff", 
                    marginLeft: "15px" 
                  }}>
                    {item.label}
                  </span>
                </Link>
              ))}
              
              {/* Logout Button */}
              <div 
                className="premium-nav-item" 
                onClick={logout}
                style={{
                  display: 'flex', alignItems: 'center', padding: '15px 25px',
                  color: '#ff5f5f', cursor: 'pointer', marginTop: '5px'
                }}
              >
                 <div style={{ width: '32px', display: 'flex', justifyContent: 'center', fontSize: '22px' }}>
                    <FaPowerOff />
                 </div>
                 <span style={{ fontWeight: '600', fontSize: '15.5px', marginLeft: "15px" }}>Logout</span>
              </div>
            </div>
          </div>

          {/* Main Top Header */}
          <div className="header-top" style={{ background: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }}>
            <div className="w3-container">
              <div className={css.headerContainer} style={{ display: 'flex', alignItems: 'center', height: '68px' }}>
                <button className="hambergar_btn" onClick={w3_open} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px' }}>
                    <img src="/images/LandingPage_img/sidebar2.png" alt="menu" style={{ width: '32px' }} />
                </button>

                <Link to="/" style={{ marginLeft: '12px' }}>
                    <img src="/images/addanew.png" alt="logo" style={{ height: '45px' }} />
                </Link>

                <div className="d-flex align-items-center" style={{ gap: "10px", marginLeft: "auto" }}>
                  {/* Wallet Badge */}
                  <Link to="/Addcase" className="premium-badge" style={{
                      backgroundColor: "#f0f7ff", borderRadius: "50px", padding: "5px 4px",
                      border: "1.5px solid #cbdcf0", height: "40px", display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#1a202c'
                    }}>

                    <img src="/images/global-rupeeIcon.png" alt="wallet" style={{ width: "24px", marginRight: "8px" }} />
                    <span style={{ fontSize: "15px", fontWeight: "750" }}>₹{user?.Wallet_balance || 0}</span>
                    <div style={{ 
                        backgroundColor: "#00c853", borderRadius: "50%", width: "20px", height: "20px", 
                        marginLeft: "10px", display: 'flex', justifyContent: 'center', alignItems: 'center',
                        boxShadow: '0 2px 6px rgba(0,200,83,0.3)'
                    }}>
                      <BsPlus size={16} color="#fff" />
                    </div>
                  </Link>

                  {/* Earning Badge */}
                  <Link to="/redeem/refer" className="premium-badge" style={{
                      backgroundColor: "#f0f7ff", borderRadius: "50px", padding: "5px 14px",
                      border: "1.5px solid #cbdcf0", height: "40px", display: 'flex', alignItems: 'center', textDecoration: 'none', color: '#1a202c'
                    }}>
                    <img src="/images/notification-activity-reward.png" alt="earning" style={{ width: "26px", marginRight: "8px" }} />
                    <span style={{ fontSize: "15px", fontWeight: "750" }}>{user?.referral_wallet || '0.00'}</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        /* Unauthenticated Header */
        <div className="w3-white" style={{ boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
          <div className="w3-container">
            <div className={`${css.headerContainer} justify-content-between`} style={{ height: '68px', display: 'flex', alignItems: 'center' }}>
              <Link to="/">
                  <img src="/images/addanew.png" alt="logo" style={{ height: '45px' }} />
              </Link>
              <Link className="login-btn" to="/login" style={{
                background: '', color: '#fff', 
                padding: '10px 28px', borderRadius: '10px', textDecoration: 'none', 
                fontWeight: 'bold', fontSize: '14px', boxShadow: '0 4px 15px rgba(19,94,105,0.3)'
              }}>
                LOGIN
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;

